module.exports = __webpack_public_path__ + "static/img/icon1.a61728d8.png";